/* eslint-disable @typescript-eslint/no-explicit-any */
type Callback = (context: WebWorkerServer, args: any) => void;

class WebWorkerServer {
  private events: { [key: string]: Array<Callback> };

  private context: Worker;

  constructor(context: Worker) {
    this.events = {};
    this.context = context;
    this.context.addEventListener('message', (e) => {
      const { topic } = e.data;
      this.exec(topic, e.data);
    });
  }

  on(topic: string, callback: Callback) {
    if (!this.events[topic]) {
      this.events[topic] = [];
    }
    this.events[topic].push(callback);
    return this;
  }

  exec(topic: string, data: any) {
    if (!Array.isArray(this.events[topic])) {
      return this;
    }
    this.events[topic].forEach((event) => {
      event(this, data);
    });
    return this;
  }

  send(topic: string, payload = {}) {
    this.context.postMessage({ topic, ...payload });
    return this;
  }
}

export default WebWorkerServer;
